import { Card, Form } from '@ksyos/design-system';
import type { EpisodeCategory } from '@common/enums';
import { ManagerAuthorization } from '@common/enums';
import { translateKey } from '@frontend/translate';
import { hasOneAuthorization } from '@frontend/utils';
import type { IServiceReaderWithServices } from '../../../interfaces/serviceReader';
import type { IServiceSupervisor } from '../../../interfaces/serviceSupervisor';
import { DateSettings } from './DateSettings';
import { TurnRightOffLink } from './TurnRightOffLink';

interface IPersonalSettingsCarePathServiceReaderSupervisorSettingProps {
    episodeCategory: EpisodeCategory;
    organizationId: string;
    reloadServiceRights: () => Promise<void>;
    serviceRight?: IServiceReaderWithServices | IServiceSupervisor;
    serviceRightType: 'ServiceReader' | 'ServiceSupervisor';
}

export function PersonalSettingsCarePathServiceReaderSupervisorSetting(
    props: IPersonalSettingsCarePathServiceReaderSupervisorSettingProps
) {
    if (!props.serviceRight) {
        return null;
    }

    return (
        <Card>
            <Card.Transition type={'read'} />
            <Card.Header
                title={getHeaderText(props.serviceRightType, props.episodeCategory, props.serviceRight.service.name)}
            />
            <Card.Body>
                <Form submitOnEnter={false}>
                    <DateSettings serviceRight={props.serviceRight} />
                </Form>
            </Card.Body>
            {!props.serviceRight.endDate && hasOneAuthorization(ManagerAuthorization.employmentSettingsEdit) && (
                <Card.Footer>
                    <TurnRightOffLink
                        organizationId={props.organizationId}
                        reloadServiceRights={props.reloadServiceRights}
                        serviceRight={props.serviceRight}
                        serviceRightType={props.serviceRightType}
                    />
                </Card.Footer>
            )}
        </Card>
    );
}

function getHeaderText(
    serviceRightType: 'ServiceReader' | 'ServiceSupervisor',
    episodeCategory: EpisodeCategory,
    serviceName: string
) {
    if (serviceRightType === 'ServiceReader') {
        return `${translateKey('addCarePathSectionTitles.serviceReaderSettings')} ${translateKey(
            `episodeCategoryEnum.${episodeCategory}`
        )}`;
    }

    return `${translateKey('addCarePathSectionTitles.serviceSupervisorSettings')} ${serviceName}`;
}
